import { ChildType, SingleChildType } from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import { Child, Children } from 'service/dto/children.dto';
import { errorHandler } from 'utils';

class ChildrenService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createChildren = async (children: ChildType) => {
    try {
      const response = await this.baseService.post(
        '/children/create',
        children
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  updateChildren = async (
    childrenId: number | null,
    children: SingleChildType
  ) => {
    try {
      const response = await this.baseService.put(
        `/children/${childrenId}`,
        children
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getChildrens = async (search?: string | undefined): Promise<Children> => {
    try {
      const response = await this.baseService.get(`/children?search=${search}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deleteChildren = async (childId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(`/children/${childId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getChildren = async (childId: number): Promise<Child> => {
    try {
      const response = await this.baseService.get(`/children/${childId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default ChildrenService;
